import * as React from "react";
import { ProcessOrder } from "../components/thankyou/processOrder";
export interface ThankyouPageProps {
}
export const ThankyouPage = (props: ThankyouPageProps) => {
    return (
        <ProcessOrder />
    );
}